import React, { useState, useContext } from "react";
import { AuthContext } from "context/AuthContext";
import { showToast } from "ui/components/common";
import { getUser } from "lib/actions"; // Ensure getUser fetches user by ID
import UserSelect from "pages/dashboard/schedule/components/userSelect";
import { shareCase } from "pages/dashboard/cases/service";
import { Modal, Input, Select } from "antd";
import "./share-case-modal.scss";
const ShareCaseModal = ({ isOpen, onRequestClose, caseId }) => {
  const { user } = useContext(AuthContext);
  const [contactInfo, setContactInfo] = useState("");
  const [expiration, setExpiration] = useState("1440"); // Default to 1 day (1440 minutes)
  const [selectedUsers, setSelectedUsers] = useState([]); // State to store selected users from UserSelect
  const [shareSubmitting, setShareSubmitting] = useState(false);
  const [note, setNote] = useState("");
  const clearForm = () => {
    setContactInfo("");
    setNote("");
    setExpiration("1440");
    setSelectedUsers([]); // Clear selected users
  };

  const handleClose = () => {
    clearForm();
    onRequestClose();
  };

  const handleUserSelect = (selectedOptions) => {
    // Set selected users to their `value` (user ID)
    const userIds = selectedOptions.map((option) => option.value); // Extract user IDs
    setSelectedUsers(userIds); // Store just the user IDs in state
    console.log("Selected User IDs: ", userIds);
  };
  const handleShare = async () => {
    const emailArray = [];
    const phoneNumberArray = [];
    const contacts = contactInfo.split(/[\s,;]+/).filter((contact) => contact);

    let hasInvalidContact = false;

    contacts.forEach((contact) => {
      if (/^\d{10}$/.test(contact)) {
        phoneNumberArray.push(contact);
      } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) {
        emailArray.push(contact);
      } else {
        hasInvalidContact = true;
      }
    });

    if (hasInvalidContact) {
      showToast(1, "Please enter valid email addresses and phone numbers.");
      return;
    }

    for (const userId of selectedUsers) {
      const data = await getUser(user.token, user.orgId, userId);
      console.log("Fetched User Details: ", data);
      const userDetails = data?.data?.user;
      console.log("User Details: ", userDetails);
      if (userDetails) {
        const email = userDetails.email;
        const phone = userDetails.phoneNumber;

        if (email) {
          emailArray.push(email);
        }
        if (phone) {
          phoneNumberArray.push(phone);
        }
      }
    }

    console.log("Emails: ", emailArray);
    console.log("Phone Numbers: ", phoneNumberArray);
    setShareSubmitting(true);
    const res = await shareCase(
      caseId,
      emailArray,
      phoneNumberArray,
      expiration,
      note,
      user.orgId,
    );
    setShareSubmitting(false);
    if (res.status !== 200) {
      showToast(1, "Failed to share case. Please try again later.");
      return;
    }
    showToast(0, "Case shared successfully!", { minWidth: 300 });
    handleClose();
  };

  return (
    <Modal
      // className="setting-results-modal"
      title={<p className="text-lg font-semibold">Share Case</p>}
      open={isOpen}
      closable={false}
      centered
      okText="Share"
      okButtonProps={{
        disabled:
          (contactInfo == "" && selectedUsers.length == 0) || shareSubmitting,
        className:
          "rounded-xl px-5 py-6 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 disabled:bg-[#222222] disabled:bg-opacity-15 disabled:hover:bg-[#222222] disabled:hover:bg-opacity-15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed",
      }}
      cancelButtonProps={{
        className:
          "rounded-xl mr-3 bg-white px-5 py-6 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50",
      }}
      onOk={handleShare}
      onCancel={handleClose}
    >
      <div className="mt-6 share-case-modal">
        <div className="mb-2">Select Users</div>
        <UserSelect
          className="bigInput"
          role={""}
          maxSelectNumber={15}
          onChange={handleUserSelect} // Pass handleUserSelect to capture selected users
          value={selectedUsers} // Set the value to the selected users state
        />
        <div className="my-2">Share With Users</div>
        <Input
          className="h-[54px] rounded-2xl px-2"
          placeholder="Enter user names, email addresses or mobile numbers."
          value={contactInfo}
          onChange={(e) => {
            setContactInfo(e.target.value);
          }}
        />
      </div>
      <div className="share-case-select-container mt-4">
        <div className="mb-2">Expiration Time</div>
        <Select
          className="drawer-select"
          popupClassName="share-case-select-dropdown"
          style={{ width: "100%", borderRadius: "16px" }}
          dropdownStyle={{ borderRadius: "16px", padding: "4px 0" }}
          value={expiration}
          onChange={(value) => {
            setExpiration(value);
          }}
          defaultValue={"1440"}
          options={[
            { value: "1440", label: "1 day" },
            { value: "4320", label: "3 days" },
            { value: "10080", label: "1 week" },
          ]}
        />
      </div>
      <div className="mt-4 pb-6">
        <div className="mb-2">Note</div>
        <Input.TextArea
          onChange={(e) => setNote(e.target.value)}
          placeholder="Write a note"
          autoSize={{ minRows: 3, maxRows: 5 }}
        />
      </div>
    </Modal>
  );
};

export default ShareCaseModal;
